<template>
  <b-link :id="scrollPosition > 0 ? 'scrollPosit' : ''"
          v-b-tooltip.hover
          :class="scrollPosition === 0 ? 'confirmarRegistroBox' : 'confirmarRegistroBox fixBox'">
    <div class="row col-12 rowConfirmar">
      <button class="btn btn-secondary btn-sm"
              type="button"
              :disabled="selectedRegisters.length === 0 ? true : false"
              @click="confirmaRegistros()">
        Confirmar registros
      </button>
    </div>
  </b-link>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'BoxConfirmaLoteRegistros',
    props: {
      registros: {
        type: Array,
        default: []
      },
      selectedRegisters: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        scrollPosition: 0
      }
    },
    computed: {
      ...mapGetters({
        scroll: 'window/getScroll',
        window: 'window/getWindow'
      })
    },
    created () {
      // Criamos um evento para calcular a posição do box de acordo com o scroll
      window.addEventListener('scroll', () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight
        const scrolled = window.scrollY

        const scrollPosit = document.getElementById('scrollPosit')
        
        this.scrollPosition = (scrollable - scrolled) <= 180 ? 180 - (scrollable - scrolled) : 0

        if (scrollPosit) {
          scrollPosit.setAttribute('style', `--position: ${this.scrollPosition}px`)
        }
      })
    },
    methods: {
      confirmaRegistros () {
        this.$emit('confirmaRegistros', this.selectedRegisters)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .confirmarRegistroBox {
    position: fixed;
    bottom: 0vh;
    width: pxToRem(1160);
    height: pxToRem(55);
    background-color: white;
    border-style: solid;
    border-color: $color-gray;
    border-width: 1px;
    cursor: auto;

    @media(min-width: pxToRem(790)) {      
      @include calc(width, pxToRem(725), null);
      @include calc(right, '(100vw - #{pxToRem(730)}) / 2', null);
    }
    
    @media(min-width: pxToRem(1024)) {
      @include calc(width, pxToRem(1024), null);
      @include calc(right, '(100vw - #{pxToRem(1028)}) / 2', null);
    }

    @media(min-width: pxToRem(1160)) {
      @include calc(width, pxToRem(1160), null);
      @include calc(right, '(100vw - #{pxToRem(1165)}) / 2', null);
    }
  }

  .fixBox {
    bottom: var(--position);
  }

  .rowConfirmar {
    margin-top: 0.7rem !important;
    justify-content: flex-end;
    margin-right: 0;
    padding-right: 15px;
    margin-left: 0;
    border-right-width: 15px;
    cursor: auto;
  }
</style>
